import { render, staticRenderFns } from "./FooterVue.vue?vue&type=template&id=5a0a0782"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"
import style0 from "./FooterVue.vue?vue&type=style&index=0&id=5a0a0782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports